// INDEX
<template>
   <div :class="['page-static']">
      <StaticPageModuleRenderer
         v-if="pageData?.content"
         v-for="data in pageData.content"
         :data="data"
         :key="data.key"
      />
      <NuxtPage />
   </div>
</template>
<script setup lang="ts">
const { getPage, queryStaticPage } = useStaticPage();

// >> DATA QUERY ---------------------------------------

const { data, error } = await useAsyncData(`staticPages-homepage`, () =>
   queryStaticPage("homepage" as string)
);

const pageData = computed(() => data.value ?? getPage.value);
// >> SET GLOBAL STATE ---------------------------------
// >> COMPUTED/WATCHERS --------------------------------
// >> LIFECYCLE  ---------------------------------------
// >> SEO & TRANSITION ---------------------------------
// useSeoHelper(pageData.value?.seo, pageData.value?.globalSeo);
useSeoHelper({ title: pageData.value?.title });
definePageMeta({
   name:"homepage",
   layout: "logged-out",
   middleware: "school-homepage",
});
</script>
